import createVueComponent from '../createVueComponent';

const ChevronDown = createVueComponent('ChevronDownIcon', [
  ['path', { d: 'm6 9 6 6 6-6', key: 'qrunsl' }],
]);

export default ChevronDown;
